import { Assinatura } from "./assinatura";
import { Sistema } from "./sistema";
import { TipoDocumento } from "./tipo-documento";
import { Servidor } from "./servidor";
export class Documentos {
  dtDatalog: Date = null;
  idDocumento: number = null;
  sistema: Sistema = null;
  assinante: Servidor = null;
  dsOrigem: string = null;
  snLiberado: string = null;
  tipoDocumento: TipoDocumento = null;
  bbDocumento: Blob = null;
  dsExtensao: string = null;
  dtPublico: Date = null;
  snSigiloso: string = null;
  assinatura: Assinatura = null;
  /*localidade: number = null;
	tpAssinatura: string = null;
  dsUsuariolog: string = null;
  snOriginal: string = null;
	snConjunto: string = null;
tpAssinador: string = null;
	dsObs: string = null;
  bbEscaneado: string = null;
	dsResumo: string = null;
  fkIdDocumento: number = null;
  */
  constructor(d?) {
    if (d) {
      this.dtDatalog = d.dtDatalog ? d.dtDatalog : null;
      this.idDocumento = d.idDocumento ? d.idDocumento : null;
      this.tipoDocumento = d.tipoDocumento
        ? new TipoDocumento(d.tipoDocumento)
        : null;
      this.sistema = d.sistema ? new Sistema(d.sistema) : null;
      this.assinante = d.assinante ? new Servidor(d.assinante) : null;
      // this.cdLocalidade = d.cdLocalidade ? d.cdLocalidade : null;
      // this.tpAssinatura = d.tpAssinatura ? d.tpAssinatura : null;
      this.dsOrigem = d.dsOrigem ? d.dsOrigem : null;
      // this.dsUsuariolog = d.dsUsuariolog ? d.dsUsuariolog : null;
      this.bbDocumento = d.bbDocumento ? d.bbDocumento : null;
      this.snLiberado = d.snLiberado ? d.snLiberado : null;
      this.dsExtensao = d.dsExtensao ? d.dsExtensao : null;
      // this.snOriginal = d.snOriginal ? d.snOriginal : null;
      this.dtPublico = d.dtPublico ? d.dtPublico : null;
      // this.snConjunto = d.snConjunto ? d.snConjunto : null;
      // this.tpAssinador = d.tpAssinador ? d.tpAssinador : null;
      // this.dsObs = d.dsObs ? d.dsObs : null;
      // this.bbEscaneado = d.bbEscaneado ? d.bbEscaneado : null;
      this.snSigiloso = d.snSigiloso ? d.snSigiloso : null;
      // this.dsResumo = d.dsResumo ? d.dsResumo : null;
      // this.fkIdDocumento = d.fkIdDocumento ? new Iddocumento(d.fkIdDocumento) : null;
      this.assinatura = d.assinatura ? new Assinatura(d.assinatura) : null;
    }
  }

  documentoValido(): Blob {
    let d: Blob = null;
    if (this.assinatura) {
      if (this.assinatura.dtAssinatura && this.assinatura.bbDocumentopdf) {
        d = this.assinatura.bbDocumentopdf;
      } else {
        d = this.bbDocumento;
      }
    } else {
      d = this.bbDocumento;
    }
    return d;
  }

  nomeArquivo(nome?: string): string {
    let d: string = nome;
    if (this.assinatura) {
      if (this.assinatura.dtAssinatura && this.assinatura.bbDocumentopdf) {
        d = d + ".pdf";
      } else {
        d = d + this.dsExtensao;
      }
    } else {
      d = d + this.dsExtensao;
    }
    return d;
  }
}
